import '@/config/locale'; // Ensure FR locale is loaded before anything else
import { initSentry } from "@/lib/sentry";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

initSentry();

createRoot(document.getElementById("root")!).render(<App />);
